export default {
  name: 'project_name',
  component_path: 'modules/procedures/blocks/BlockInputText',
  static_mandatory: ['required', 'minLength:3'],
  default_value: 'project.name'
}